var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHumansignal = function SvgHumansignal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81287 0.0460205C5.97884 0.0460205 5.30273 0.722132 5.30273 1.55615V9.14115C5.30273 9.14886 5.30279 9.15655 5.30291 9.16422V5.34868H10.6054V10.6513H14.3975C15.2316 10.6513 15.9077 9.97517 15.9077 9.14115V1.55615C15.9077 0.72213 15.2316 0.0460205 14.3975 0.0460205H6.81287Z",
    fill: "#FFA663"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09485 15.9539C9.92887 15.9539 10.605 15.2777 10.605 14.4437V6.85872C10.605 6.85415 10.605 6.84958 10.6049 6.84501V10.6512H5.30245V5.3486H9.10027C9.09847 5.34859 9.09666 5.34859 9.09485 5.34859H1.51017C0.676146 5.34859 3.62396e-05 6.0247 3.62396e-05 6.85873V14.4437C3.62396e-05 15.2777 0.676145 15.9539 1.51017 15.9539H9.09485Z",
    fill: "#FF7557"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHumansignal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "humansignal.35449cfc24427e1dd8fb72fa7bf9ba07.svg";